import { render, staticRenderFns } from "./ConfigBillets.vue?vue&type=template&id=13debb99&scoped=true"
import script from "./ConfigBillets.vue?vue&type=script&lang=js"
export * from "./ConfigBillets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13debb99",
  null
  
)

export default component.exports